import React from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";

const RangeBarTimeline = ({ graphOptions, dataTestId }) => {
  const { options, series } = graphOptions;

  return (
    <div data-test-id={dataTestId} className="chart-item">
      <Chart
        options={options}
        series={series}
        type="rangeBar"
        width={options.width}
        height={options.height}
      />
    </div>
  );
};

RangeBarTimeline.propTypes = {
  graphOptions: PropTypes.shape({
    options: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    series: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  dataTestId: PropTypes.string,
};

RangeBarTimeline.defaultProps = {
  dataTestId: PropTypes.isNull,
};

export default RangeBarTimeline;
